import { LowerCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ButtonComponent } from '../../../../../../../../../../shared/components/button/button.component';
import { DotPulseComponent } from '../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { MmrService } from '../../../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim } from '../../../../../../../../types/mmr-claims.type';
import { StatusNameMappingPipe } from '../../repair-tracker-timeline.utils';
import { CourierCollectionComponent } from './active-step-descriptions/courier-collection/courier-collection.component';
import { EngineerVisitComponent } from './active-step-descriptions/engineer-visit/engineer-visit.component';
import { NewVisitComponent } from './active-step-descriptions/new-visit/new-visit.component';
import { OutCardLeftComponent } from './active-step-descriptions/out-card-left/out-card-left.component';
import { RemedialWorkComponent } from './active-step-descriptions/remedial-work/remedial-work.component';
import { SelfSendComponent } from './active-step-descriptions/self-send/self-send.component';
import { SpContactCustomerComponent } from './active-step-descriptions/sp-contact-customer/sp-contact-customer.component';
import { WaitingForPartsComponent } from './active-step-descriptions/waiting-for-parts/waiting-for-parts.component';

@Component({
  selector: 'app-tracker-current-step',
  imports: [
    DotPulseComponent,
    StatusNameMappingPipe,
    WaitingForPartsComponent,
    EngineerVisitComponent,
    ButtonComponent,
    RemedialWorkComponent,
    NewVisitComponent,
    ButtonComponent,
    OutCardLeftComponent,
    LowerCasePipe,
    SelfSendComponent,
    CourierCollectionComponent,
    SpContactCustomerComponent,
  ],
  templateUrl: './tracker-current-step.component.html',
  styleUrl: './tracker-current-step.component.scss',
})
export class TrackerCurrentStepComponent {
  step = input.required<any>();
  claimType = input.required<'repair' | 'service'>();

  serviceOptionType = input.required<string>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claim = claims.value()?.[this.claimType()] as ClaimDetailsPanelViewClaim;
    const claimId = claim?.id;
    const fullId = claim?.fullId ?? claim?.id;
    const status: string = this.step()?.status;

    return {
      status,
      cancel: claim?.actions?.cancel,
      rebooking: claim?.actions?.rebooking,
      trackable: claim?.actions?.trackable,
      rebookingURL: [fullId, 'rebook'],
      trackingURL: [fullId, 'track'],
      claimId,
      fullId: fullId,
      claimType: this.claimType(),
      rms: claims.value()?.planOverview?.repairSystem,
      isTvRemoteReplacement: claim?.metaData?.['isTvRemoteReplacement'],
      originalStatusIncludesFirst: ((this.step().meta ?? {}).originalStatus ?? '').toLowerCase().includes('1st'),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}

  cancelClaim() {
    this.mmrService.performClaimCancel(this.vm.fullId, this.vm.rms);
  }
}
